import useKitchenOrder from './useKitchenOrder';

export default useKitchenOrder;
